module.exports = __webpack_public_path__ + "img/law4m.d446e3a5.jpg";